import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { Collapse, Pagination, BackTop, Dropdown, Menu, Affix } from 'antd';
import classNames from 'classnames';
import { apiHolder as api, apis, apiHolder } from 'api';
import MailTag from '../MailTag/MailTag';
import { ReactComponent as FilterCheckedIcon } from '@/images/icons/filter_checked.svg';
import { changeContentByLocal, systemIsWindow, transTag2Name, isLockTag } from '../../util';
import './index.scss';
import Toobar from './Toobar';
import { useAppSelector } from '@web-common/state/createStore';
import TitleWithContextMenu from './component/TitleContextMenu/TitleWithContextMenu';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { MergeMailLoading } from './component/Loadings';
import { THREAD_MAIL_PAGE_SIZE } from '../../common/constant';
import useDebounceLocalData from '../../hooks/useDebounceLocalData';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import ContentSearch from './ContentSearch';
import { ReactComponent as BackToTopNew } from '@/images/icons/back_to_top_new.svg';
import { getIn18Text } from 'api';
import { useContactModelNames } from '@web-common/hooks/useContactModel';
const mailManagerApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const eventApi = api.api.getEventApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
import { ReactComponent as ArrowDown } from '@/images/icons/arrow-down.svg';
import MergePanelMail from './MergePanelMail';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import PinHead from './component/PinHead/PinHead';
import styles from './index.module.scss';
const systemApi = api.api.getSystemApi();
const htmlApi = apiHolder.api.requireLogicalApi(apis.htmlApi);
const AffixMergeHeader = props => {
    const { target, disable = false } = props;
    const [isPin] = useState2RM('fixedReadMailHeader');
    return isPin && !disable ? (React.createElement(Affix, { offsetTop: 0, target: target, className: styles.fixedHedContent },
        React.createElement("div", { className: styles.fixedMergeMailHead }, props.children))) : (React.createElement(React.Fragment, null, props.children));
};
const MergeMail = props => {
    var _a;
    const { handleDelete, handleRemark, onChangeMail, searchInputVisible, setSearchInputVisible, id, activeKey, content, mailList, readOnly = false, threadPageConfig, onPageChange, featureConfig, handleTranslateLang, translateInfoMidMap, isUpDown, forceUpdate, ContentMeasurement, VrticalScrollWrapComponent, unlockMail, onOrderChange, mergeMailOrderDesc, freezeMouse, } = props;
    const contentRef = useRef([]);
    const contentScrollRef = useRef(null);
    const [searchIndex, setSearchIndex] = useState(-1);
    const [searchCount, setSearchCount] = useState(0);
    const [keyword, setKeyword] = useState('');
    const currentSearchState = useRef({
        index: -1,
        count: 0,
        text: '',
        matchCase: false,
        wholeWord: false,
        inSelection: false,
        firstFind: false,
        openIframeKeys: [],
        merge: true,
    });
    const localContent = useDebounceLocalData(content, {
        exception: data => { var _a, _b; return !!((_b = (_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content); },
    });
    const [showMailHeadMap, setShowMailHeadMap] = useState({});
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const inWindows = useMemo(() => systemIsWindow(), []);
    useEffect(() => {
        currentSearchState.current.index = -1;
        currentSearchState.current.count = 0;
        currentSearchState.current.text = '';
        currentSearchState.current.firstFind = true;
        currentSearchState.current.openIframeKeys = [];
        setSearchCount(0);
        setSearchIndex(-1);
        setSearchInputVisible(false);
        setShowMailHeadMap({});
    }, [id]);
    useMsgRenderCallback('mailMenuOper', ev => {
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'searchInContent') {
            setSearchInputVisible(true);
        }
    });
    const handleSignlDelete = useCallback((mailId) => {
        var _a;
        if (mailList.length <= 1) {
            handleDelete &&
                handleDelete(id, true, {
                    threadId: id,
                    showLoading: false,
                    showGlobalLoading: true,
                });
        }
        else {
            const messageKey = id + '';
            message.loading({ content: getIn18Text('YOUJIANSHANCHUZHONG'), duration: 30, key: messageKey });
            mailApi
                .doDeleteMail({ fid: (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder, id: mailId })
                .then(res => {
                if (res && res.succ) {
                    message.success({
                        content: getIn18Text('YOUJIANSHANCHUCHENG'),
                        duration: 2,
                        key: messageKey,
                    });
                }
            })
                .catch(() => {
                message.error({ content: getIn18Text('YOUJIANSHANCHUSHI'), duration: 2, key: messageKey });
            });
        }
    }, [mailList]);
    const ToobarElement = useMemo(() => {
        return React.createElement(Toobar, { content: content, mailList: mailList, btnTheme: "light" });
    }, [localContent, mailList]);
    const handleDeleteTag = (tagName, _mailList) => {
        const ids = _mailList.map(_ => _.entry.id);
        eventApi.sendSysEvent({
            eventName: 'mailTagChanged',
            eventData: {
                tagNames: [tagName],
                mailList: ids,
            },
            eventStrData: 'untag',
        });
    };
    const TagElement = useMemo(() => {
        var _a;
        const showTag = !(localContent === null || localContent === void 0 ? void 0 : localContent.isTpMail);
        return showTag ? (React.createElement("div", { className: "mail-group-tag-warp", "data-test-id": "mail-thread-tag" }, (_a = localContent === null || localContent === void 0 ? void 0 : localContent.tags) === null || _a === void 0 ? void 0 : _a.map(item => (React.createElement(MailTag, { className: "tag", closeable: !readOnly && (featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.mailTagIsCloseAble) && !isLockTag(item), color: mailManagerApi.getTagColor(item, true), style: { color: mailManagerApi.getTagFontColor(item) }, onClose: () => {
                handleDeleteTag(item, [localContent]);
            } }, transTag2Name(item)))))) : (React.createElement(React.Fragment, null));
    }, [localContent, readOnly]);
    const senderContactMap = useContactModelNames({
        emails: (mailList || [])
            .filter(item => {
            if (item && item.sender && item.sender.contact && item.sender.contact.contact) {
                return true;
            }
            return false;
        })
            .map(item => {
            return item.sender.contact.contact.accountName;
        }),
        _account: (content === null || content === void 0 ? void 0 : content._account) || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id),
    });
    const MailContentElement = useMemo(() => {
        var _a, _b;
        return (React.createElement("div", { className: "mail-group-wrap", hidden: !mailList || mailList.length <= 0 },
            React.createElement(Collapse, { activeKey: activeKey, ghost: true, onChange: onChangeMail, defaultActiveKey: mailList && mailList.length ? [(_b = (_a = mailList[0]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.id] : [] }, mailList.map((_item, key) => {
                var _a, _b, _c;
                let item = _item;
                let showAttachCount = 0;
                if ((_b = (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.length) {
                    (_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.attachment.forEach(att => {
                        if (!att.inlined) {
                            showAttachCount++;
                        }
                    });
                }
                if (_item && _item.entry.langType && _item.entry.langListMap) {
                    try {
                        const langListMap = _item.entry.langListMap;
                        const langType = _item.entry.langType;
                        const result = langListMap[langType];
                        if (result) {
                            item = changeContentByLocal(langType, result, item);
                        }
                    }
                    catch (e) {
                        console.error('[Error mergeMail translate]', e);
                        item = _item;
                    }
                }
                return (React.createElement(MergePanelMail, { key: item.entry.id, activeKey: activeKey, handleSignlDelete: handleSignlDelete, readOnly: readOnly, featureConfig: featureConfig, senderContactMap: senderContactMap, showAttachCount: showAttachCount, handleRemark: handleRemark, ckey: key, handleTranslateLang: handleTranslateLang, translateInfoMidMap: translateInfoMidMap, unlockMail: unlockMail, forceUpdate: forceUpdate, replayFixed: mailList.length > 0, content: item, freezeMouse: freezeMouse, contentRef: contentRef }));
            }))));
    }, [
        mailList,
        activeKey,
        readOnly,
        featureConfig,
        handleTranslateLang,
        translateInfoMidMap,
        forceUpdate,
        showMailHeadMap,
        forceUpdate,
        Object.keys(senderContactMap).length,
        freezeMouse,
    ]);
    const LoadingElement = useMemo(() => {
        const list = (isCorpMail ? localContent.entry.threadMessageIds : new Array(threadPageConfig.pageSize)) || [];
        return mailList && mailList.length > 0 ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: "mail-group-wrap" }, list.map(() => (React.createElement(MergeMailLoading, null)))));
    }, [localContent, mailList, isCorpMail]);
    const NoMoreElement = useMemo(() => {
        if (!isCorpMail) {
            const firstPageShowRule = threadPageConfig.total <= threadPageConfig.pageSize && threadPageConfig.current == 1;
            const lastPageShowRule = mailList && mailList.length <= threadPageConfig.pageSize && threadPageConfig.current == Math.ceil(threadPageConfig.total / threadPageConfig.pageSize);
            if (firstPageShowRule || lastPageShowRule) {
                return (React.createElement("div", { "data-test-id": "mail-thread-no-more", className: "mail-content-no-more" }, getIn18Text('WUGENGDUOYOUJIAN')));
            }
        }
        return React.createElement(React.Fragment, null);
    }, [isCorpMail, threadPageConfig, mailList]);
    const ThreadPaginationElement = useMemo(() => {
        if (!isCorpMail && threadPageConfig.total > threadPageConfig.pageSize) {
            return (React.createElement("div", { className: "mail-content-pagination-wrap", "data-test-id": "mail-thread-pager" },
                React.createElement(Pagination, { showSizeChanger: false, current: threadPageConfig.current, defaultCurrent: 1, defaultPageSize: THREAD_MAIL_PAGE_SIZE, total: threadPageConfig.total, pageSize: threadPageConfig.pageSize, onChange: (page, pageSize) => {
                        onPageChange && onPageChange(page, pageSize);
                    } }),
                React.createElement("div", { className: "pagination-info" }, getIn18Text('TIAO/YE', { count: THREAD_MAIL_PAGE_SIZE }))));
        }
        return React.createElement(React.Fragment, null);
    }, [isCorpMail, threadPageConfig, onPageChange]);
    const readOnlyTopEmpty = useMemo(() => {
        return readOnly ? React.createElement("div", { style: { height: 20 } }) : React.createElement(React.Fragment, null);
    }, []);
    const searchContent = (keyword, forward = true) => {
        var _a, _b;
        if (currentSearchState.current.text !== keyword ||
            currentSearchState.current.openIframeKeys.length !== activeKey.length ||
            currentSearchState.current.openIframeKeys.some(c => !activeKey.includes(c))) {
            currentSearchState.current.index = -1;
            currentSearchState.current.count = 0;
            currentSearchState.current.firstFind = true;
            currentSearchState.current.openIframeKeys = [];
        }
        if (contentRef.current) {
            const openPages = contentRef.current.filter(item => item && activeKey.includes(item.key));
            if (!openPages.length && keyword) {
                message.error('仅支持搜索已展开的邮件正文,请展开邮件后再试');
            }
            let nextIndex = null;
            for (let i = 0; i < openPages.length; i++) {
                const item = openPages[i];
                if (currentSearchState.current.firstFind)
                    currentSearchState.current.openIframeKeys.push(item.key || '');
                const searchFind = (_b = (_a = item.getIframeRef().current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.searchFind;
                const index = typeof searchFind === 'function' && searchFind(currentSearchState.current, keyword, forward);
                if (index !== undefined)
                    nextIndex = index;
            }
            currentSearchState.current.firstFind = false;
            if (nextIndex !== null) {
                currentSearchState.current.index = nextIndex;
                setSearchIndex(nextIndex);
                setSearchCount(currentSearchState.current.count);
            }
        }
    };
    useEffect(() => {
        if (searchInputVisible === false) {
            setSearchCount(0);
            setSearchIndex(-1);
        }
    }, [searchInputVisible]);
    const handleMenuClick = e => {
        const key = e.key;
        onOrderChange && onOrderChange(key);
    };
    const trimTitle = useMemo(() => {
        return htmlApi.decodeHtml(content.entry.title.trim());
    }, [content.entry.title]);
    return (React.createElement(VrticalScrollWrapComponent, { className: `u-block ${inWindows ? 'u-block-win' : ''} thread-mail-warp`, style: { marginRight: '1px' }, ref: contentScrollRef },
        React.createElement(ContentMeasurement, null,
            React.createElement("div", { className: classNames({
                    'u-block-content': true,
                    'u-block-content-updown': isUpDown,
                }) },
                React.createElement(AffixMergeHeader, { target: () => contentScrollRef.current, disable: readOnly || isUpDown },
                    readOnly || isUpDown ? React.createElement(React.Fragment, null) : ToobarElement,
                    React.createElement("div", { style: { marginBottom: '10px' } },
                        React.createElement(ContentSearch, { searchInputVisible: searchInputVisible, setSearchInputVisible: setSearchInputVisible, keyword: keyword, setKeyword: setKeyword, index: searchIndex, count: searchCount, searchContent: searchContent })),
                    readOnlyTopEmpty,
                    React.createElement("div", { className: "merge-mail-title-wrap" },
                        React.createElement(TitleWithContextMenu, { className: "u-block-title" },
                            content.entry && content.entry.title ? (React.createElement(React.Fragment, null,
                                React.createElement("b", { "data-test-id": "mail-thread-title" }, trimTitle),
                                getIn18Text('DESUOYOUYOUJIAN'))) : (getIn18Text('WUZHUTI')),
                            content.entry.threadMessageIds && content.entry.threadMessageIds.length > 1 ? `(${content.entry.threadMessageIds.length})` : ''),
                        React.createElement("div", { className: "mt-oper-warp" },
                            React.createElement("div", { className: "mt-sort" },
                                React.createElement(Dropdown, { trigger: ['click'], overlayClassName: "mt-sort-menu-warp", overlay: React.createElement(Menu, { selectedKeys: [mergeMailOrderDesc ? 'desc' : 'other'], selectable: true, onClick: handleMenuClick },
                                        React.createElement(Menu.Item, { key: "desc" },
                                            React.createElement("span", { style: { marginRight: '10px' } }, getIn18Text('SHIJIANYOUJINDAOY')),
                                            mergeMailOrderDesc ? React.createElement(FilterCheckedIcon, null) : React.createElement(React.Fragment, null)),
                                        React.createElement(Menu.Item, { key: "other" },
                                            React.createElement("span", { style: { marginRight: '10px' } }, getIn18Text('SHIJIANYOUYUANDAOJ')),
                                            mergeMailOrderDesc ? React.createElement(React.Fragment, null) : React.createElement(FilterCheckedIcon, null))) },
                                    React.createElement("span", null,
                                        getIn18Text('YOUJIANPAIXU'),
                                        " ",
                                        React.createElement(ArrowDown, null)))),
                            readOnly || isUpDown ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: styles.mrPingHeadWrap },
                                React.createElement(PinHead, null))))),
                    TagElement),
                MailContentElement,
                LoadingElement,
                NoMoreElement,
                ThreadPaginationElement,
                React.createElement(BackTop, { visibilityHeight: 200, target: () => contentScrollRef.current || window, className: "read-mail-back-top-icon", "data-test-id": "read-backtop" },
                    React.createElement(BackToTopNew, null))))));
};
export default MergeMail;
